export default function isNotNumber(item) {
  return typeof item !== 'number' && !!item
}
